import TextField from '@material-ui/core/TextField';
import { withStyles } from '@material-ui/core/styles';

const VehiclesGroupsTagsStyled = withStyles((theme) => ({
  root: {
    '& label': {
      '&.MuiFormLabel-root': {
        color: theme.palette.form.labelColor,
        fontSize: theme.typography.fontSize,
        paddingLeft: 16,
      },
      '&.Mui-focused': {
        color: theme.palette.primary.main,
        paddingLeft: 0,
      },
      '&.Mui-error': {
        color: theme.palette.error.main,
        paddingLeft: 0,
      },
    },
    '& .MuiInputBase-input': {
      fontSize: theme.typography.appFontSize,
      padding: '6px 12px 6px 16px !important',
    },
    '& .MuiInput-underline:hover:not(.Mui-disabled):before': {
      borderBottomColor: theme.palette.form.border,
    },
    '& .MuiInput-underline:before': {
      borderBottomColor: theme.palette.form.border,
    },
    '& .MuiFormHelperText-root': {
      fontSize: theme.typography.pxToRem(11),
    },
    '& .MuiAutocomplete-tag': {
      background: theme.palette.primary.main,
      height: '24px',
      color: '#fff',
      fontSize: '11px',

      '& svg': {
        color: '#fff',
        height: '16px',
      },
    },
  },
}))(TextField);

export default VehiclesGroupsTagsStyled;
